import { useState, useEffect } from "react"

interface GridWrapperProps {
  show: boolean,
  columns: number,
  margin: number,
  children: JSX.Element
}

export default function GridWrapper({ show, columns, margin, children }: GridWrapperProps) {
  const [hasHidden, setHasHidden] = useState(false)
  
  useEffect(() => {
    if (!show) {
      setHasHidden(true)
    }
  }, [show])

  let animationClass = show ? "windmillShow" : "windmillHide"
  if (!hasHidden) {
    animationClass = ""
  }

  return (
    <section id="gridContainer" className={animationClass}>
      <div id="grid"
        style={{
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: margin + "%"
        }}>
        {children}
      </div>
    </section>
  )
}